//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    layout: '500error',

}
